import SmartAnalyticsComponent from '../Components/SmartAnalytics/SmartAnalyticsComponent';

function SmartAnalyticsPage() {
  return <SmartAnalyticsComponent />;
}

export default SmartAnalyticsPage;
